
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// Gestion de la page panier est ce qui est en lien avec
require('./components/cart');
require('./components/delivery');

// Gestion du backoffice admin
require('./components/admin');
// Gestion des sélecteur couleur, taille etc
require('./components/selector');
// Gestion des slider homepage & page catégorie
require('./components/slider');
// Gestion de la page profil
require('./components/profile');

// tooltip
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

// menu

const elementClicked = document.querySelector(".burger");
const elementToShow = document.querySelector(".menu-mobile");

elementClicked.addEventListener("click", ()=>{
    elementToShow.classList.toggle("menu-hide");
});